<template>
    <div class="input_container">
        <van-field v-model="localValue" type="number" :placeholder="labelText" @clear="onClear"
            class="custom-field">
            <!-- Left icon: R$ -->
            <template #left-icon>
                <div class="left-section">
                    <span class="left_icon">R$ </span>
                </div>
            </template>

            <!-- Right icon: PIX -->
            <template #right-icon>
                <div class="right-wrapper">
                    <van-icon v-if="localValue" name="clear" class="custom-clear" @click.stop="onClear" />
                    <div class="right_text" v-if="props.isTopupVisible">
                        {{ $t('deposit.extra') }}
                        <span class="extra_amount">+{{ formatCurrency(giftAmount) }}</span>
                    </div>
                    <div class="right-section" v-else>
                        <img src="@/assets/pix.png" alt="PIX" class="pix-icon" />
                    </div>
                </div>
            </template>
        </van-field>
    </div>
</template>

<script setup lang="ts">
import { formatCurrency } from '@/utils/commonFunction'
import { ref, watch, defineProps, defineEmits } from 'vue'

const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: ''
    },
    labelText: {
        type: String,
        default: ''
    },
    isTopupVisible: {
        type: Boolean,
        default: false
    },
    giftAmount: {
        type: Number,
        default: 0
    }
})

const emit = defineEmits(['update:modelValue', 'valueChanged'])

const localValue = ref(props.modelValue)

watch(() => props.modelValue, (newVal) => {
    localValue.value = newVal
})

watch(localValue, (val) => {
    emit('update:modelValue', val)
    emit('valueChanged', val)
})
const onClear = () => {
    localValue.value = ''
    emit('update:modelValue', '')
    emit('valueChanged', '')
}
</script>
<style scoped>
.input_container :deep(.van-field) {
    border-radius: 0.0188rem;
    background: #2c1d31 !important;
    border: 1px solid #65436f;
    color: #ffffffd9;
    padding: 8px 10px !important;
    margin-top: 10px;
}

.left_icon {
    color: #ffcb52;
    font-size: 20px;
    font-weight: bold;
    padding-right: 10px;
    border-right: 2px solid #65436f;
}

.input_container :deep(.van-field__control) {
    color: #fff !important;
    padding-left: 12px !important;
    font-weight: 400 !important;
}

.input_container :deep(.van-field__control::placeholder) {
    color: #fd66b1 !important;
    opacity: 1 !important;
}

/* Right side */
.right-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.pix-icon {
    width: 40px;
    opacity: 0.5;
}

.right_text {
    color: #c08eba;
}

.extra_amount {
    color: #fff;
    padding: 0 5px;
}

/* Custom clear button */
.custom-clear {
    font-size: 18px;
    color: #fff;
    opacity: 0.6;
    cursor: pointer;
}

.custom-clear:hover {
    opacity: 1;
}
</style>